import { render, staticRenderFns } from "./FramePage.vue?vue&type=template&id=2bcd7d79&scoped=true&"
import script from "./FramePage.vue?vue&type=script&lang=js&"
export * from "./FramePage.vue?vue&type=script&lang=js&"
import style0 from "./FramePage.vue?vue&type=style&index=0&id=2bcd7d79&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcd7d79",
  null
  
)

export default component.exports